import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgFire = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "none", ref, ...props, children: /* @__PURE__ */ jsx(
    "path",
    {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M18.122 17.645a7.2 7.2 0 0 1-2.656 2.495 7.06 7.06 0 0 1-3.52.853 6.6 6.6 0 0 1-3.306-.718 6.73 6.73 0 0 1-2.54-2.266c-2.672-4.57.287-8.846.887-9.668A4.45 4.45 0 0 0 8.07 6.31 4.5 4.5 0 0 0 7.997 4c1.284.965 6.43 3.258 5.525 10.631 1.496-1.136 2.7-3.046 2.846-6.216 1.43 1.061 3.985 5.462 1.754 9.23"
    }
  ) })
);

export { SvgFire as default };
//# sourceMappingURL=fire.mjs.map
